import React, {useState, useEffect} from 'react';
import Get from '../components/Get';
import MoreBottomTab from '../MoreBottomTab';

const PostFree = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    Get.Wallet('win')
      .then(res => {
        setLoading(false);
        if (res.transection && res.transection.length > 0) {
          const flatTransactions = res.transection.flatMap(group => group.data);
          if (flatTransactions.length > 0) {
            setData(flatTransactions);
          } else {
            setData([]);
          }
        } else {
          setData([]);
        }
      })
      .catch(err => {
        setLoading(false);
        console.error('Win Fetch Error:', err);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const styles = {
    headerBar: {
      height: '60px',
      backgroundColor: '#00318bff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderBottomLeftRadius: '20px',
      borderBottomRightRadius: '20px',
      boxShadow: '0 5px 10px rgba(0, 0, 0, 0.3)',
    },
    headerTitle: {
      color: 'white',
      fontWeight: 'bold',
      fontSize: '18px',
    },
    loader: {
      textAlign: 'center',
      margin: '20px',
      fontSize: '18px',
      color: '#333',
    },
    content: {
      padding: '16px',
    },
    cardRow: {
      backgroundColor: 'white',
      margin: '10px 16px',
      padding: '16px',
      borderRadius: '12px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    rowTop: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '8px',
    },
    gameName: {
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#333',
    },
    dateText: {
      fontSize: '12px',
      color: '#888',
    },
    rowBottom: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    amountText: {
      fontSize: '18px',
      fontWeight: 'bold',
    },
    statusText: {
      fontSize: '12px',
      color: '#999',
      marginLeft: '10px',
    },
    noData: {
      textAlign: 'center',
      marginTop: '50px',
      color: '#555',
    },
  };

  return (
    <>
      <div>
        <div style={styles.headerBar}>
          <h1 style={styles.headerTitle}>Win History</h1>
        </div>
        {loading ? (
          <div style={styles.loader}>Loading...</div>
        ) : (
          <div style={styles.content}>
            {data && data.length > 0 ? (
              data.map((item, index) => {
                let color = 'black';
                if (item.transection === 'debit') {
                  color = item.status === 'success' ? 'red' : '#ffc107';
                } else {
                  color = item.status === 'success' ? 'green' : '#ffc107';
                }
                return (
                  <div style={styles.cardRow} key={index}>
                    <div style={styles.rowTop}>
                      <p style={styles.gameName}>{item.message}</p>
                      <p style={styles.dateText}>{item.date}</p>
                    </div>
                    <div style={styles.rowBottom}>
                      <p style={{...styles.amountText, color}}>
                        {item.transection === 'debit' ? '-' : '+'}
                        {item.amount}
                      </p>
                      {item.status === 'process' && (
                        <p style={styles.statusText}>{item.status}</p>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div style={styles.noData}>
                <p>No Transaction Available</p>
              </div>
            )}
          </div>
        )}
      </div>
      <MoreBottomTab />
    </>
  );
};

export default PostFree;
